module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-intervention-request-form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [
    [_c('label', [_vm._v("Status"), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.localValue.status),
        expression: "localValue.status"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.localValue, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((['NEW', 'ASSIGNED', 'IN_PROGRESS', 'COMPLETED', 'REFUSED']), function(status) {
      return _c('option', [_vm._v(_vm._s(status))])
    }), 0)])], (!_vm.localValue.has_linked_requests) ? _c('selectize-maintenance-driver', {
      attrs: {
        "value-field": "id",
        "selectedValue": _vm.localValue.maintenance_driver_id
      },
      model: {
        value: (_vm.localValue.maintenance_driver_id),
        callback: function($$v) {
          _vm.$set(_vm.localValue, "maintenance_driver_id", $$v)
        },
        expression: "localValue.maintenance_driver_id"
      }
    }) : _vm._e(), [_c('label', [_vm._v("Start")]), _c('date-picker', {
      attrs: {
        "format": "yyyy-mm-dd hh:ii:ss",
        "pick-time": "pick-time",
        "initial-date": _vm.localValue.start_at
      },
      model: {
        value: (_vm.localValue.start_at),
        callback: function($$v) {
          _vm.$set(_vm.localValue, "start_at", $$v)
        },
        expression: "localValue.start_at"
      }
    }), _c('label', [_vm._v("Expiry")]), _c('date-picker', {
      attrs: {
        "format": "yyyy-mm-dd hh:ii:ss",
        "pick-time": "pick-time",
        "initial-date": _vm.localValue.expiry
      },
      model: {
        value: (_vm.localValue.expiry),
        callback: function($$v) {
          _vm.$set(_vm.localValue, "expiry", $$v)
        },
        expression: "localValue.expiry"
      }
    })]
  ], 2), _c('div', {
    staticClass: "column"
  }, [(!_vm.edit) ? [_c('label', [_vm._v("Disable for booking"), _c('input-switch', {
    model: {
      value: (_vm.localValue.create_reservation),
      callback: function($$v) {
        _vm.$set(_vm.localValue, "create_reservation", $$v)
      },
      expression: "localValue.create_reservation"
    }
  })], 1)] : _vm._e(), (_vm.localValue.hasOwnProperty('vehicle_id') && !_vm.subRequest) ? _c('selectize-vehicle', {
    attrs: {
      "value-field": "id",
      "selectedValue": _vm.localValue.vehicle_id,
      "disabled": _vm.localValue.linked_intervention_request_id !== null
    },
    model: {
      value: (_vm.localValue.vehicle_id),
      callback: function($$v) {
        _vm.$set(_vm.localValue, "vehicle_id", $$v)
      },
      expression: "localValue.vehicle_id"
    }
  }) : _vm._e(), _c('label', [_vm._v("Priority"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue.priority),
      expression: "localValue.priority"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.localValue, "priority", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Minor")]), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Medium")]), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Major")])]), _c('label', [_vm._v("Type"), (_vm.edit) ? [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue.type),
      expression: "localValue.type"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.localValue, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "CLEANING"
    }
  }, [_vm._v("Cleaning")]), _c('option', {
    attrs: {
      "value": "ROUTINE"
    }
  }, [_vm._v("Routine")]), _c('option', {
    attrs: {
      "value": "PREPARATION"
    }
  }, [_vm._v("Preparation")]), _c('option', {
    attrs: {
      "value": "CHECK_OUT"
    }
  }, [_vm._v("Check-out")]), _c('option', {
    attrs: {
      "value": "REPOSITIONING"
    }
  }, [_vm._v("Repositioning")]), _c('option', {
    attrs: {
      "value": "ACCIDENT"
    }
  }, [_vm._v("Accident")]), _c('option', {
    attrs: {
      "value": "EXTERIOR_REPAIR"
    }
  }, [_vm._v("Exterior repair")]), _c('option', {
    attrs: {
      "value": "RECHARGE"
    }
  }, [_vm._v("Recharge")]), _c('option', {
    attrs: {
      "value": "LOW_BATTERY"
    }
  }, [_vm._v("Low Battery")])])] : _vm._l((['CLEANING', 'ROUTINE', 'PREPARATION', 'CHECK_OUT', 'REPOSITIONING', 'ACCIDENT', 'EXTERIOR_REPAIR', 'RECHARGE', 'LOW_BATTERY']), function(type) {
    return [_c('label', [_vm._v(_vm._s(type) + "  "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.localValue.type),
        expression: "localValue.type"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": type,
        "checked": Array.isArray(_vm.localValue.type) ? _vm._i(_vm.localValue.type, type) > -1 : (_vm.localValue.type)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.localValue.type,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = type,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.localValue, "type", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.localValue, "type", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.localValue, "type", $$c)
          }
        }
      }
    })])]
  })], 2)])], 2)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Description")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localValue.description),
      expression: "localValue.description"
    }],
    attrs: {
      "rows": "10"
    },
    domProps: {
      "value": (_vm.localValue.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localValue, "description", $event.target.value)
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-66747daa!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/forms/InterventionRequestForm.vue
// module id = 2559
// module chunks = 1